export default {
  PROVIDE_FIRST_NAME: "First name is required",
  PROVIDE_VALID_FIRST_NAME: "Please enter valid first name",
  PROVIDE_LAST_NAME: "Last name is required",
  PROVIDE_VALID_LAST_NAME: "Please enter valid last name",
  PROVIDE_EMAIL: "Email is required",
  PROVIDE_VALID_EMAIL: "Please enter valid email",
  PROVIDE_SECONDARY_EMAIL: "Secondary email is required",
  PROVIDE_VALID_SECONDARY_EMAIL: "Please enter valid secondary email",
  PROVIDE_MOBILE: "Mobile is required",
  PROVIDE_VALID_MOBILE: "Please enter valid mobile",
  PROVIDE_PHONE: "Phone is required",
  PROVIDE_VALID_PHONE: "Please enter valid phone",
  PROVIDE_GENDER: "Select valid gender type",
  PROVIDE_WORK_PREFRENCE: "Select valid work prefrence",
  PROVIDE_NOTICE_PERIOD: "Select valid Notice period",
  PROVIDE_QUALIFICATION: "Highest Qualification is required",
  PROVIDE_SKILL_SET: "Skill set is required",
  PROVIDE_TOTAL_EXPERIENCE: "Total Experience is required",
  PROVIDE_VALID_TOTAL_EXPERIENCE:
    "Total Experience should be greater than relevant experience",
  PROVIDE_RELEVENT_EXPERIENCE: "Relevant Experience is required",
  PROVIDE_VALID_RELEVENT_EXPERIENCE:
    "Relevant Experience should be less than total experience",
  PROVIDE_CURRENT_SALARY: "Currently salary is required",
  PROVIDE_EXPECTED_SALARY: "Expected salary is required",
  PROVIDE_CURRENT_DESIGNATION: "Current designation is required",
  PROVIDE_CURRENT_EMPLOYER: "Current employer is required",
  PROVIDE_ONE_EDUCATION: "Please add at least one education detail",
  PROVIDE_CITY: "City is required",
  PROVIDE_VALID_CITY: "Please enter valid city",
  PROVIDE_COUNTRY: "Country is required",
  RE_UPLOAD_CV: "Are you sure you want to update your resume ?",
};
